import React from 'react';
import {getItemPrice} from '../helpers/common';
import FormattedPrice from './FormattedPrice';
import './ItemAddToCartBtn.scss';

const ItemAddToCardBtn = ({t, orderItem, isNewItem, onAddToCart}) => {
  return (
    <div
      className={ 'btn btn-primary add-to-cart-button hvr-shutter-out-horizontal' }
      onClick={ onAddToCart }
    >
      <div className={ 'text' }>
        {isNewItem ? t('add_item_modal.add_to_card') : t('buttons.update')}
      </div>
      <div className={ 'price' }>
        <FormattedPrice price={ getItemPrice(orderItem, true, true) } />
      </div>
    </div>
  );
};

export default ItemAddToCardBtn;
